import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import React, {useContext} from 'react'
import useToggle from 'react-use-toggle';
import camelCase from 'lodash/camelCase';
import Icon from 'react-icons-kit';
import {chevronRight} from 'react-icons-kit/fa/chevronRight';

import * as actions from '../../store/actions';
import ListItem from '../ListItem';
import ManualNav from '../ManualNav/ManualNav';
import {NavAccordionContext} from '../ManualNav/NavAccordion';

import styles from './ManualNavItem.module.css';

const _ManualNavItem = props => {

  const {
    id,
    navLevel = 0,
    closeMenu,
    page,
    setCurrentPage
  } = props;

  const hasSubpages = page ? (page.subpages && page.subpages.length > 0) : false;

  const accordion = useContext(NavAccordionContext);
  const [localExpanded, toggleLocal] = useToggle(props.isOpenAncestor);

  // Top level sections share a single slot so only one is ever open. Deeper levels
  // keep their own state, otherwise opening a child would collapse the parent
  // holding it.
  const exclusive = navLevel === 0;
  const expanded = exclusive ? accordion.openSectionId === id : localExpanded;
  const toggleExpanded = exclusive ? () => accordion.toggleSection(id) : toggleLocal;

  // Landing on a top level page should reveal its subpages, so following the link
  // opens the section. Idempotent, so re-visiting an open section leaves it open.
  const navigate = () => {
    setCurrentPage(page.slug);
    if (exclusive) accordion.openSection(id);
  }

  return (page) ? (
    <ListItem className={[styles.ManualNavItem, styles[`Level${navLevel}`]].join(' ')}>
      <div className={styles.NavRow}>
        {hasSubpages ?
          <button
            type="button"
            className={[styles.Toggle, expanded ? styles.Expanded : styles.Collapsed].join(' ')}
            aria-expanded={expanded}
            aria-label={`${expanded ? 'Collapse' : 'Expand'} ${page.title}`}
            onClick={toggleExpanded}><Icon size={14} icon={chevronRight}/></button>
          : <span className={styles.ToggleSpacer} />
        }
        <NavLink 
          className={[styles.NavLink, styles[`Level${navLevel}`]].join(' ')} 
          activeClassName={styles.Active} 
          to={'/manual/' + page.slug}
          onClick={navigate}
          onMouseUp={closeMenu}>{page.title}</NavLink>
      </div>
      {hasSubpages && expanded ? <ManualNav pagelist={page.subpages} navLevel={navLevel + 1} closeMenu={closeMenu} /> : null }
    </ListItem>
  ) : null;
}

const mapStateToProps = ({pages}, ownProps) => {
  const allPages = pages.pages ? pages.pages : {};
  const sluggedPage = pages.sluggedPages && pages.currentPage ? pages.sluggedPages[camelCase(pages.currentPage)] : false;
  const currentPage = sluggedPage ? allPages[sluggedPage.id] : false;

  // Walk parentId up from the page being read, for nested levels that open themselves.
  // Resolved to a boolean rather than a list so this does not re-render on every
  // store change.
  let isOpenAncestor = false;
  for (let parentId = currentPage ? currentPage.parentId : false; parentId; parentId = (allPages[parentId] ? allPages[parentId].parentId : false)) {
    if (parentId === ownProps.id) {
      isOpenAncestor = true;
      break;
    }
  }

  return {
      page: allPages[ownProps.id] ? allPages[ownProps.id] : false,
      isOpenAncestor
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setCurrentPage: (slug) => dispatch(actions.setCurrentPage(slug))
  }
}

const ManualNavItem = connect(mapStateToProps,mapDispatchToProps)(_ManualNavItem) //Make new component so that this works recursively

export default ManualNavItem
